let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dD4CQ")).then(() => parcelRequire('2PKid'));